import { graphql } from 'gatsby';
import propTypes from 'prop-types';
import React, { useMemo } from 'react';

import TagTitle from '../components/TagTitle';
import ProductCard from '../components/ProductCard';
import ProductGrid from '../components/ProductGrid';
import Layout from '../layouts/Layout';
import { productFactory } from '../services/productFactory';

const Tag = ({ data }) => {
  const products = useMemo(() => {
    return data.allMarkdownRemark.nodes.map(productFactory);
  }, [data]);

  return (
    <Layout title={data.tagsJson.name} metaDescription={data.tagsJson.metaDescription} metaKeywords={data.tagsJson.metaKeywords}>
      <div className="w-full">
        <TagTitle title={data.tagsJson.name} metaTitle={data.tagsJson.metaTitle} shortDescription={data.tagsJson.shortDescription} longDescription={data.tagsJson.longDescription} />
        <div className="text-black text-xl sm:text-2xl font-bold lg:text-2xl leading-none pb-6 pt-4">Cannabis products related to "{data.tagsJson.name}"</div>
        <ProductGrid>
          {products.map(product => (
            <ProductCard key={product.id} product={product} />
          ))}
        </ProductGrid>
      </div>
    </Layout>
  );
};

export const query = graphql`
  query ProductsByTag($id: String!) {
    tagsJson(id: { eq: $id }) {
      name
      metaTitle
      shortDescription
      longDescription
      metaDescription
      metaKeywords
    }
    allMarkdownRemark(filter: { frontmatter: { tags: { elemMatch: { id: { eq: $id } } } } }) {
      nodes {
        id
        fields {
          slug
        }
        frontmatter {
          name
          price
          image {
            childImageSharp {
              fluid(maxWidth: 272, maxHeight: 363, quality: 50) {
                ...GatsbyImageSharpFluid_withWebp_tracedSVG
              }
            }
          }
          seller {
            id
            name
          }
        }
      }
    }
  }
`;

Tag.propTypes = {
  data: propTypes.shape({
    tagsJson: propTypes.shape({
      name: propTypes.string,
      metaDescription: propTypes.string,
      metaKeywords: propTypes.string,
      shortDescription: propTypes.string,
      longDescription: propTypes.string,
      metaTitle: propTypes.string,
    }),
    allMarkdownRemark: propTypes.shape({
      nodes: propTypes.array,
    }).isRequired,
  }).isRequired,
};

export default Tag;
